/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./FontIcon.vue.js?vue&type=template&id=1f930dc7!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./FontIcon.vue?vue&type=template&id=1f930dc7"
import script from "./FontIcon.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./FontIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./FontIcon.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./FontIcon.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FontIcon.vue.postcss?vue&type=style&index=0&id=1f930dc7&prod&lang=postcss!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./FontIcon.vue?vue&type=style&index=0&id=1f930dc7&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports